import { render } from "./saktaTransport.vue?vue&type=template&id=68a2cf1a&scoped=true"
import script from "./saktaTransport.vue?vue&type=script&lang=js"
export * from "./saktaTransport.vue?vue&type=script&lang=js"

import "./saktaTransport.vue?vue&type=style&index=0&id=68a2cf1a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68a2cf1a"]])

export default __exports__